import Alpine from 'alpinejs';

Alpine.store('modals', {
    modalsOpen: 0,

    update(int) {
        this.modalsOpen = this.modalsOpen + int;
    }
})